import { render, staticRenderFns } from "./PhieuKhamBenh.vue?vue&type=template&id=1ec1a266&scoped=true"
import script from "./PhieuKhamBenh.vue?vue&type=script&lang=js"
export * from "./PhieuKhamBenh.vue?vue&type=script&lang=js"
import style0 from "./PhieuKhamBenh.vue?vue&type=style&index=0&id=1ec1a266&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ec1a266",
  null
  
)

export default component.exports